<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="line">
            <div class="file-grid">
                <ng-container
                    *ngIf="asyncFiles | async as files; else noFilesTemplate"
                >
                    <ng-container *ngIf="files?.length; else noFilesTemplate">
                        <div *ngFor="let file of files">
                            <div class="file-item" [title]="file.name">
                                <div class="file-icon">
                                    <mat-icon>picture_as_pdf</mat-icon>
                                </div>
                                <div class="file-name">{{ file.name }}</div>
                                <div
                                    class="file-delete"
                                    title="Eliminar archivo"
                                >
                                    <mat-icon class="icon">close</mat-icon>
                                </div>
                                <a
                                    class="file-visibility"
                                    target="_blank"
                                    title="Ver archivo"
                                >
                                    <mat-icon class="icon">visibility</mat-icon>
                                </a>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-template #noFilesTemplate>
                    <div class="file-item" style="text-align: center">
                        Aún no tienes archivos disponibles
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
